import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ConditionalValidatorParams } from './conditional-validator-params';

export function conditionalValidator(params: ConditionalValidatorParams): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (params.predicate()) {
      return params.validator(control);
    }

    return null;
  };
}
